<template>
  <comment-list-layout v-if="loaded"
                       ref="commentListLayout"
                       :review-data="review"
                       :render-data="render"
                       page-type="mission"
                       :work-id="workId"
                       @load-comment="fetchReviewExplore"
                       @send-comment="fetchReviewCreate"
                       @like-comment="fetchReviewLike"
  >
    <div class="million-read-mission">
      <div class="million-read-mission-header">
        <div class="million-read-mission-user-info">
          <ym-avatar class="million-read-mission-user-info-avatar"
                     :avatar="userInfo.avatar"
                     v-ym-report:MILLION_VIP_USER_HOMEPAGE_ENTER_WORK_DETAIL_CLICK="{
                       workId: workId,
                     }"
                     @click="handleToUserCenter(userInfo.id)"
          />
          <div class="million-read-mission-user-info-detail">
            <div class="million-read-mission-user-info-name">
              <span>{{ userInfo.name }}</span>
              <ym-img v-if="vip.status === 'normal'"
                      class="vip-icon"
                      :src="require('@/assets/img/million_read/vip_icon.png')"
              />
            </div>
            <div class="million-read-mission-user-info-create-time">
              发表于：{{ mission.createdTime | formatTime('yyyy-MM-dd') }}
            </div>
          </div>
        </div>
        <ym-img v-if="render && render.isRecommend"
                class="million-read-mission-header-recommend-icon"
                :src="require('@/assets/img/million_read/work/recommend_deco.png')"
        />
      </div>
      <div class="million-read-mission-content"
           v-html="mission.content"
      ></div>
      <div class="million-read-mission-action">
        <div class="million-read-mission-action-like-block">
          <div class="million-read-mission-action-like-action-block"
               v-ym-report:MILLION_VIP_MISSION_LIKE_CLICK="{
                 workId: workId,
                 approve: like.isLiked,
               }"
               @click="handleLikeMission"
          >
            <template v-if="showAnimation">
              <div class="million-read-mission-action-like-gif"
                   id="like-mission-gif"
              ></div>
            </template>
            <template v-else>
              <ym-icon v-if="like.isLiked"
                       class="million-read-mission-action-like-icon"
                       name="zan-hl"
              />
              <ym-icon v-else
                       class="million-read-mission-action-like-icon"
                       name="zan-nor"
              />
            </template>
          </div>
          <div class="million-read-mission-action-like-desc">
            <template v-if="like.isLiked">
              <template v-if="like.count - 1 === 0">
                我觉得很赞
              </template>
              <template v-else>
                我和其他<span class="high-light">{{ like.count - 1 }}</span>人都觉得很赞
              </template>
            </template>
            <template v-else>
              <template v-if="like.count !== 0">
                <span class="high-light">{{ like.count }}</span>人觉得很赞
              </template>
              <template v-else>
                鼓励一下
              </template>
            </template>
          </div>
        </div>
        <div class="million-read-mission-action-share-block">
          <div class="million-read-mission-action-share-header">
            <div class="line"></div>
            <span class="desc">分享至</span>
            <div class="line"></div>
          </div>
          <div class="million-read-mission-action-share-list"
               @click="handleShowShareMask"
          >
            <div class="million-read-mission-action-share-list-item"
                 v-ym-report:MILLION_VIP_MISSION_SHARE_CLICK="{
                   workId,
                   platform: 'wechatAppShare',
                 }"
            >
              <ym-icon class="icon"
                       name="WeChat"
              />
              <span>微信</span>
            </div>
            <div class="million-read-mission-action-share-list-item"
                 v-ym-report:MILLION_VIP_MISSION_SHARE_CLICK="{
                   workId,
                   platform: 'wechatTimeline',
                 }"
            >
              <ym-icon class="icon"
                       name="pengyouquan1"
              />
              <span>朋友圈</span>
            </div>
            <div class="million-read-mission-action-share-list-item"
                 v-ym-report:MILLION_VIP_MISSION_SHARE_CLICK="{
                   workId,
                   platform: 'weibo',
                 }"
            >
              <ym-icon class="icon"
                       name="weibo1"
              />
              <span>微博</span>
            </div>
            <div class="million-read-mission-action-share-list-item"
                 v-ym-report:MILLION_VIP_MISSION_SHARE_CLICK="{
                   workId,
                   platform: 'qq',
                 }"
            >
              <ym-icon class="icon"
                       name="QQ"
              />
              <span>QQ</span>
            </div>
          </div>
        </div>
      </div>
      <div class="million-read-mission-book">
        <div class="million-read-mission-book-block-title">阅读的书籍</div>
        <div class="million-read-mission-book-block"
             @click="handleProductDetail"
        >
          <div class="million-read-mission-book-cover-container">
            <ym-img class="million-read-mission-book-cover"
                    :src="audio.cover"
            />
          </div>
          <div class="million-read-mission-book-detail">
            <div class="million-read-mission-book-title ym-two-line-ellipsis">
              {{ audio.title }}
            </div>
            <div class="million-read-mission-book-summary ym-line-ellipsis">
              {{ audio.summary }}
            </div>
            <div class="million-read-mission-book-tag-list">
              <div class="million-read-mission-book-tag-list-item"
                   v-for="(item, index) in audio.tag"
                   :key="index"
              >
                {{ item }}
              </div>
            </div>
            <div class="million-read-mission-book-total-program">共{{ audio.totalProgram }}讲</div>
          </div>
        </div>
      </div>
      <share-mask :show.sync="showShareMask"
                  :share-path="$wechat.getWechatMenuShareAppLink()"
                  message="请复制下方链接，前往粘贴给好友"
      />
    </div>
  </comment-list-layout>
</template>

<script>
  import lottie from 'lottie-web';
  import missionLikeAction from '@/assets/img/million_read/json/mission-like-action.json';
  import CommentListLayout from '@/layout/CommentListLayout';
  import YmAvatar from '@/components/Avatar';
  import ShareMask from '@/components/ShareMask';
  import {
    getMissionDetail,
    millionWorkLike,
    missionDetailReviewExplore,
    missionDetailReviewCreate,
    missionDetailReviewLike,
  } from '@/services/million-read';
  import { getProductPath, locationPath } from '@/utils';
  import { LIMIT } from '@/utils/constant';

  export default {
    name: 'MillionReadMission',
    metaInfo: {
      title: '',
    },
    components: {
      CommentListLayout,
      'ym-avatar': YmAvatar,
      ShareMask,
    },
    data() {
      return {
        userInfo: null,
        audio: null,
        mission: null,
        like: null,
        vip: {
          status: '',
        },
        render: null,
        loaded: false,
        review: {},
        reviewStart: 0,

        showShareMask: false,
        showAnimation: false,
      };
    },
    computed: {
      workId() {
        return parseInt(this.$route.query.id, 10);
      },
    },
    methods: {
      handleToUserCenter(id) {
        this.$router.push({
          name: 'MillionReadUserCenter',
          query: {
            userId: id,
          },
        });
      },
      async fetchReviewExplore() {
        const params = {
          workId: this.workId,
          start: this.reviewStart,
          limit: LIMIT,
          requestTime: this.review.requestTime,
        };
        const data = await missionDetailReviewExplore(params);
        this.reviewStart = data.start;
        this.$refs.commentListLayout.handleFetchData('loadComment', data);
      },
      async fetchReviewCreate(replyId, content) {
        const data = await missionDetailReviewCreate(replyId, content, this.workId);
        this.reviewStart += 1;
        this.$refs.commentListLayout.handleFetchData('sendComment', data);
      },
      async fetchReviewLike(item) {
        const action = item.like.liked ? 'unlike' : 'like';
        await missionDetailReviewLike(item.id, action);
        this.$refs.commentListLayout.handleFetchData('likeComment', item);
      },
      init(id, json) {
        this.$nextTick(() => {
          const icon = document.getElementById(id);
          const gif = lottie.loadAnimation({
            container: icon, // 包含动画的dom元素
            renderer: 'svg', // 渲染出来的是什么格式
            loop: false, // 循环播放
            autoplay: true, // 自动播放
            animationData: json, // 动画json的路径
          });
          gif.stop();
          gif.play();
          gif.addEventListener('complete', () => {
            this.showAnimation = false;
          });
        });
      },
      async fetchData(workId) {
        const data = await getMissionDetail(workId);
        this.userInfo = data.userInfo;
        this.audio = data.audio;
        this.mission = data.mission;
        this.like = data.like;
        this.vip = data.vip;
        this.render = Object.assign({
          pageTitle: '',
          showReview: true,
        }, data.render);
        this.reviewStart = data.review.start;
        this.review = data.review;
        this.loaded = true;
      },
      handleShowShareMask() {
        this.showShareMask = true;
      },
      async handleLikeMission() {
        const action = this.like.isLiked ? 'unlike' : 'like';
        await millionWorkLike(this.workId, action);
        if (action === 'unlike') {
          this.like.count -= 1;
          this.like.isLiked = false;
        } else {
          this.showAnimation = true;
          this.init('like-mission-gif', missionLikeAction);
          this.like.count += 1;
          this.like.isLiked = true;
        }
      },
      handleProductDetail() {
        locationPath(getProductPath(this.audio.type, this.audio.id));
      },
    },
    created() {
      this.fetchData(this.workId);
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-mission {
    box-sizing: border-box;
    padding-bottom: 120px;
    min-height: 100%;
    background: @color-white;
    &-header {
      box-sizing: border-box;
      position: relative;
      padding: @size-medium 56px @size-large @size-medium;
      margin-bottom: @size-medium;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: linear-gradient(to bottom, #fffccd, @color-white);
      &:after {
        position: absolute;
        left: @size-medium;
        bottom: 0;
        width: 690px;
        height: 1px;
        content: '';
        background: #eee;
      }
      &-recommend-icon {
        position: absolute;
        top: @size-large;
        right: 56px;
        width: 150px;
        height: @size-medium;
      }
    }
    &-user-info {
      display: flex;
      align-items: center;
      &-detail {
        margin-left: 16px;
      }
      &-name {
        margin-bottom: @size-small;
        display: flex;
        align-items: flex-end;
        color: @color-text-base;
        font-size: @font-size-large;
        font-weight: @font-weight-bold;
        line-height: 1;
        .vip-icon {
          width: 30px;
          height: 30px;
          margin-left: 8px;
        }
      }
      &-create-time {
        color: @color-text-lighter;
        font-size: @font-size-small;
        line-height: 1;
      }
    }
    &-content {
      box-sizing: border-box;
      padding: 0 @size-base 80px @size-base;
      color: @color-text-base;
      font-size: 30px;
      line-height: 1.5;
      /deep/ img {
        display: block;
        width: 100%;
      }
    }
    &-action {
      padding: 0 @size-base 80px @size-base;
      &-like {
        &-block {
          margin-bottom: 70px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: @color-text-lighter;
          font-size: @font-size-base;
          line-height: 1.1;
          .high-light {
            color: #fea500;
          }
        }
        &-action-block {
          position: relative;
          width: 150px;
          height: 150px;
          margin: 0 auto;
        }
        &-gif {
          position: absolute;
          top: 0;
          left: 0;
          width: 150px;
          height: 150px;
          &.hidden {
            display: none;
          }
        }
        &-icon {
          margin-bottom: 20px;
          font-size: 150px;
          &.hidden {
            display: none;
          }
        }
        &-desc {
          margin-top: @size-small;
        }
      }
      &-share {
        &-header {
          margin-bottom: @size-medium;
          display: flex;
          align-items: center;
          justify-content: center;
          .line {
            width: 280px;
            height: 1px;
            content: '';
            background: @background-color-lighter;
          }
          .desc {
            width: 130px;
            color: @color-text-light;
            font-size: 26px;
            font-weight: @font-weight-strong;
            text-align: center;
          }
        }
        &-block {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        &-list {
          box-sizing: border-box;
          width: 750px;
          padding: 0 35px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          &-item {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .icon {
              margin-bottom: 14px;
              font-size: 80px;
            }
            span {
              color: @color-text-light;
              font-size: @font-size-small;
              line-height: 1.1;
            }
          }
        }
      }
    }
    &-book {
      box-sizing: border-box;
      padding: @size-large @size-base;
      border-top: 10px solid @background-color-lighter;
      &-block-title {
        margin-bottom: @size-base;
        color: @color-text-base;
        font-size: @font-size-large;
        font-weight: @font-weight-bold;
      }
      &-block {
        box-sizing: border-box;
        width: 684px;
        padding: @size-extra-medium @size-base;
        display: flex;
        background: @color-white;
        box-shadow: 0 10px 70px 0 #e4e6f2;
        border-radius: 20px;
      }
      &-cover-container {
        flex-shrink: 0;
        position: relative;
        margin-right: 24px;
      }
      &-tag {
        position: absolute;
        z-index: @z-index-large;
        top: 8px;
        left: 8px;
      }
      &-cover {
        position: relative;
        z-index: @z-index-medium;
        display: block;
        /deep/ img {
          width: 190px;
          height: 254px;
          border: 1px solid #eee5c8;
          border-radius: 4px 12px 12px 4px;
        }
      }
      &-title {
        width: 400px;
        color: @color-text-base;
        font-size: @font-size-extra-large;
        font-weight: @font-weight-bold;
        line-height: 1.2;
      }
      &-summary {
        width: 400px;
        margin-top: 16px;
        color: @color-text-lighter;
        font-size: 26px;
        line-height: 1;
      }
      &-tag-list {
        margin-top: 24px;
        display: flex;
        flex-wrap: wrap;
        &-item {
          box-sizing: border-box;
          padding: 10px 20px;
          color: #ca931b;
          font-size: @font-size-extra-small;
          line-height: 1;
          background: #fff8de;
          border-radius: 20px;
          &:not(:last-child) {
            margin-right: 16px;
          }
        }
      }
      &-detail {
        position: relative;
      }
      &-total-program {
        box-sizing: border-box;
        position: absolute;
        bottom: 0;
        left: 0;
        width: fit-content;
        padding: 6px 8px;
        color: #a1a1b3;
        font-size: @font-size-extra-extra-small;
        line-height: 1;
        word-break: keep-all;
        background: #f5f5fa;
        border-radius: 4px;
      }
    }
  }
</style>
